import { request } from '@/shared/api';
export function fetchBrandManagers() {
    return request('/api/v1/brand-managers');
}
export function fetchBrandManager(managerId) {
    return request(`/api/v1/brand-managers/${encodeURIComponent(managerId)}`);
}
